<template>
    <v-row class="justify-center">
        <v-col>
            <v-card class="text-no-wrap" min-height="200px">
                <div class="overline pl-3 pt-3" v-if="label">
                    <v-icon left v-if="icon">
                        {{ icon }}
                    </v-icon>
                    {{ label }}
                </div>

                <v-card-text
                    class="d-flex justify-space-around flex-wrap"
                    style="height=150px"
                >
                    <slot></slot>

                    <div
                        v-for="(indicator, index) in indicators"
                        :key="index"
                        style="min-heigth: 100px"
                    >
                        <plain-indicator
                            :label="indicator.label"
                            :value="indicator.value"
                            :sub="indicator.sub"
                        />
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import PlainIndicator from './PlainIndicator'

export default {
    components: {
        PlainIndicator,
    },

    props: {
        indicators: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            default: () => null,
        },
        divider: {
            type: Boolean,
            default: () => false,
        },
    },
}
</script>

<style></style>
